import { type ChangeEvent } from 'react';
import type { DashboardFiltersState, PeriodPreset } from './filters';

interface Props {
  value: DashboardFiltersState;
  onChange: (next: DashboardFiltersState) => void;
}

const PRESET_OPTIONS: { value: PeriodPreset; label: string }[] = [
  { value: 'mois', label: 'Mois en cours' },
  { value: 'trimestre', label: 'Trimestre en cours' },
  { value: 'depuis_janvier', label: 'Depuis janvier' },
  { value: 'perso', label: 'Personnalisée' },
];

export function DashboardFilters({ value, onChange }: Props): JSX.Element {
  const onPreset = (preset: PeriodPreset): void => {
    onChange({ ...value, preset });
  };
  const onCustom =
    (key: 'custom_from' | 'custom_to') =>
    (e: ChangeEvent<HTMLInputElement>): void => {
      onChange({ ...value, [key]: e.target.value });
    };
  const onUser = (e: ChangeEvent<HTMLSelectElement>): void => {
    const raw = e.target.value;
    onChange({ ...value, user_id: raw === '' ? undefined : Number(raw) });
  };

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-4 flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-xs uppercase tracking-wider text-slate-500">Période</span>
        <div className="flex rounded-md overflow-hidden border border-slate-700">
          {PRESET_OPTIONS.map((opt) => {
            const active = value.preset === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={(): void => {
                  onPreset(opt.value);
                }}
                className={`px-3 py-1.5 text-xs font-medium transition-colors ${
                  active
                    ? 'bg-floryon-green text-white'
                    : 'bg-slate-900 text-slate-300 hover:bg-slate-800'
                }`}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>

      {value.preset === 'perso' && (
        <div className="flex items-center gap-2 text-xs text-slate-300">
          <label className="flex items-center gap-1">
            du
            <input
              type="date"
              value={value.custom_from}
              onChange={onCustom('custom_from')}
              className="bg-slate-900 border border-slate-700 rounded-md px-2 py-1 text-xs text-slate-100"
            />
          </label>
          <label className="flex items-center gap-1">
            au
            <input
              type="date"
              value={value.custom_to}
              onChange={onCustom('custom_to')}
              className="bg-slate-900 border border-slate-700 rounded-md px-2 py-1 text-xs text-slate-100"
            />
          </label>
        </div>
      )}

      <div className="flex items-center gap-2 ml-auto">
        <span className="text-xs uppercase tracking-wider text-slate-500">Utilisateur</span>
        <select
          value={value.user_id === undefined ? '' : String(value.user_id)}
          onChange={onUser}
          className="bg-slate-900 border border-slate-700 rounded-md px-3 py-1.5 text-xs text-slate-100"
        >
          <option value="">Tous</option>
          <option value="1">Adam</option>
          <option value="2">Mattéo</option>
        </select>
      </div>
    </div>
  );
}
